import type { App } from 'vue';
import { StoryblokVue, apiPlugin } from '@storyblok/vue';

import CTABlok from '@/components/storyblok/CTABlok.vue';
import FAQBlok from '@/components/storyblok/FAQBlok.vue';
import FeatureGridBlok from '@/components/storyblok/FeatureGridBlok.vue';
import HeroBlok from '@/components/storyblok/HeroBlok.vue';
import ImageTextBlok from '@/components/storyblok/ImageTextBlok.vue';
import LogoBarBlok from '@/components/storyblok/LogoBarBlok.vue';
import PageBlok from '@/components/storyblok/PageBlok.vue';
import SpacerBlok from '@/components/storyblok/SpacerBlok.vue';
import StepItemBlok from '@/components/storyblok/StepItemBlok.vue';
import StepsSectionBlok from '@/components/storyblok/StepsSectionBlok.vue';
import TestimonialItemBlok from '@/components/storyblok/TestimonialItemBlok.vue';
import TestimonialSectionBlok from '@/components/storyblok/TestimonialSectionBlok.vue';
import TextBlok from '@/components/storyblok/TextBlok.vue';
import VoucherPreviewBlok from '@/components/storyblok/VoucherPreviewBlok.vue';
import VoucherQuickAddBlok from '@/components/storyblok/VoucherQuickAddBlok.vue';

/**
 * Register Storyblok Vue plugin and blok components on the given app instance.
 * Must run for both client (app.ts) and SSR (ssr.ts) so StoryblokComponent has VueSDKOptions.
 */
export function registerStoryblok(app: App, options: { bridge: boolean }): void {
    if (! import.meta.env.VITE_STORYBLOK_TOKEN) {
        return;
    }

    app.use(StoryblokVue, {
        accessToken: import.meta.env.VITE_STORYBLOK_TOKEN,
        use: [apiPlugin],
        bridge: options.bridge,
    });

    // Storyblok JSON uses snake_case `component` keys; @storyblok/vue resolves that string
    // literally — register both kebab-case and snake_case for each blok.
    app.component('page', PageBlok);
    app.component('hero', HeroBlok);
    app.component('text-section', TextBlok);
    app.component('text_section', TextBlok);
    app.component('feature-grid', FeatureGridBlok);
    app.component('feature_grid', FeatureGridBlok);
    app.component('cta', CTABlok);
    app.component('image-text', ImageTextBlok);
    app.component('image_text', ImageTextBlok);
    app.component('faq', FAQBlok);
    app.component('spacer', SpacerBlok);
    app.component('testimonial-item', TestimonialItemBlok);
    app.component('testimonial_item', TestimonialItemBlok);
    app.component('testimonial-section', TestimonialSectionBlok);
    app.component('testimonial_section', TestimonialSectionBlok);
    app.component('step-item', StepItemBlok);
    app.component('step_item', StepItemBlok);
    app.component('steps-section', StepsSectionBlok);
    app.component('steps_section', StepsSectionBlok);
    app.component('logo-bar', LogoBarBlok);
    app.component('logo_bar', LogoBarBlok);
    app.component('voucher-preview', VoucherPreviewBlok);
    app.component('voucher_preview', VoucherPreviewBlok);
    app.component('voucher-quick-add', VoucherQuickAddBlok);
    app.component('voucher_quick_add', VoucherQuickAddBlok);
}
